import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const VolumeModal = ({ isOpen, setIsOpen, editData, fetchPlans }) => {
    const [data, setData] = useState({
        volume_name: ""
    });

    useEffect(() => {
        if (editData) {
            setData({ volume_name: editData.volume_name });
        } else {
            setData({ volume_name: "" });
        }
    }, [editData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editData ? "PUT" : "POST";
        const url = editData
            ? `https://releasesworld.100billionoms.com/volume/${editData.id}`
            : "https://releasesworld.100billionoms.com/volume";

        try {
            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                toast.success(editData ? "Volume Updated" : "Volume Added");
                setData({ volume_name: "" });
                fetchPlans();
                setIsOpen(false);
            } else {
                const error = await response.json();
                toast.error(error.message);
                console.error("Server Error:", error.message);
            }
        } catch (error) {
            toast.error("Request failed");
            console.error("Request Error:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">{editData ? "Edit Volume" : "Add Volume"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Volume Name</label>
                        <input
                            type="text"
                            name="volume_name"
                            value={data.volume_name}
                            onChange={handleChange}
                            placeholder="Enter volume name"
                            required
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">
                            {editData ? "Update" : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default VolumeModal;
